const DEFAULT_DEMO_LOGIN_URL = 'https://surdurulebilirlik.ekostrateji.com/';
const DEFAULT_PLATFORM_NAME = 'EkosAI Yapay Zeka Destekli Sürdürülebilirlik Raporlama Platformu';
const DEFAULT_SUPPORT_NAME = 'Murat GÜLENÇ';
const DEFAULT_SUPPORT_TITLE = 'Ekostrateji Data Analyst, Program Developer.';
const DEFAULT_SUPPORT_PHONE = '05413355708';
const DEFAULT_SUPPORT_EMAIL = 'muratgulenc@ekostrateji.com';
const DEFAULT_RECIPIENT_NAME = 'davet edilen kullanıcı';
const DEFAULT_RECIPIENT_EMAIL = 'kullaniciadi@mail.com.tr';

const normalizeText = (value?: string | null, fallback = ''): string => {
  const text = String(value ?? '').trim();
  return text || fallback;
};

const buildSignature = (overrides?: {
  supportName?: string | null;
  supportTitle?: string | null;
  supportPhone?: string | null;
  supportEmail?: string | null;
}) => {
  const supportName = normalizeText(overrides?.supportName, DEFAULT_SUPPORT_NAME);
  const supportTitle = normalizeText(overrides?.supportTitle, DEFAULT_SUPPORT_TITLE);
  const supportPhone = normalizeText(overrides?.supportPhone, DEFAULT_SUPPORT_PHONE);
  const supportEmail = normalizeText(overrides?.supportEmail, DEFAULT_SUPPORT_EMAIL);

  return [supportName, supportTitle, supportPhone, supportEmail];
};

const buildAccessMessage = (params: {
  userName?: string | null;
  email?: string | null;
  loginUrl?: string | null;
  supportName?: string | null;
  supportTitle?: string | null;
  supportPhone?: string | null;
  supportEmail?: string | null;
}) => {
  const userName = normalizeText(params.userName, DEFAULT_RECIPIENT_NAME);
  const email = normalizeText(params.email, DEFAULT_RECIPIENT_EMAIL);
  const loginUrl = normalizeText(params.loginUrl, DEFAULT_DEMO_LOGIN_URL);

  return [
    `Merhaba ${userName};`,
    '',
    `${DEFAULT_PLATFORM_NAME} davetiniz kabul edildi.`,
    '',
    "Davet mail'i SPAM'a gelmiş olabilir. Bu maili açarak sizin için özel tanımlanan Geçici Şifre ile şifrenizi değiştirme işlemini gerçekleştirebilirsiniz.",
    '',
    'Mailde sisteme nasıl girileceği bilgileri var:',
    `1. ${loginUrl}`,
    `2. Kullanıcı Ad: ${email} mailiniz olacak`,
    "Şifre: Mail ile gelen Geçici Şifre'yi girerek, ŞİFRE DEĞİŞTİRME ekranına yönlendirileceksiniz.",
    '3. Şifrelerinizi belirleyip kaydettikten sonra artık:',
    loginUrl,
    `Kullanıcı Ad: ${email} mailiniz olacak`,
    'Şifre: Yeni belirlenen Şifre ile sisteme giriş yapabileceksiniz.',
    '',
    'Herhangi bir destek ihtiyacınız olduğunda benim ile iletişime geçebilirsiniz.',
    '',
    'İyi günler.',
    '',
    ...buildSignature({
      supportName: params.supportName,
      supportTitle: params.supportTitle,
      supportPhone: params.supportPhone,
      supportEmail: params.supportEmail,
    }),
  ].join('\n');
};

export function normalizeWhatsAppPhone(rawPhone?: string | null): string | null {
  const digits = String(rawPhone ?? '').replace(/\D+/g, '');
  if (!digits) return null;

  const withoutInternationalPrefix = digits.replace(/^00/, '');

  if (withoutInternationalPrefix.startsWith('90')) {
    return withoutInternationalPrefix;
  }

  if (withoutInternationalPrefix.startsWith('0')) {
    const localDigits = withoutInternationalPrefix.slice(1);
    if (localDigits.length === 10) {
      return `90${localDigits}`;
    }
  }

  if (withoutInternationalPrefix.length === 10) {
    return `90${withoutInternationalPrefix}`;
  }

  if (withoutInternationalPrefix.length > 10) {
    return `90${withoutInternationalPrefix.slice(-10)}`;
  }

  return null;
}

export function buildWhatsAppLink(rawPhone?: string | null, message?: string | null): string | null {
  const phone = normalizeWhatsAppPhone(rawPhone);
  if (!phone) return null;

  const text = normalizeText(message);
  return text
    ? `https://wa.me/${phone}?text=${encodeURIComponent(text)}`
    : `https://wa.me/${phone}`;
}

export function buildDemoAcceptanceWhatsAppMessage(params: {
  userName?: string | null;
  email: string;
  loginUrl?: string | null;
  supportName?: string | null;
  supportTitle?: string | null;
  supportPhone?: string | null;
  supportEmail?: string | null;
}): string {
  return buildAccessMessage({
    userName: params.userName,
    email: params.email,
    loginUrl: params.loginUrl,
    supportName: params.supportName,
    supportTitle: params.supportTitle,
    supportPhone: params.supportPhone,
    supportEmail: params.supportEmail,
  });
}

export function buildDemoInviteWhatsAppMessage(params: {
  userName?: string | null;
  companyName?: string | null;
  email: string;
  tempPassword: string;
  loginUrl?: string | null;
  platformName?: string | null;
  supportName?: string | null;
  supportTitle?: string | null;
  supportPhone?: string | null;
  supportEmail?: string | null;
}): string {
  return buildAccessMessage({
    userName: params.userName,
    email: params.email,
    loginUrl: params.loginUrl,
    supportName: params.supportName,
    supportTitle: params.supportTitle,
    supportPhone: params.supportPhone,
    supportEmail: params.supportEmail,
  });
}
